import React from 'react';
import { Box } from '@mui/material';

export const WorkspaceComposerArea = ({ children, sx }) => <Box data-workspace-composer sx={{ p: 2, borderTop: '1px solid #D6DED2', bgcolor: '#fff', ...sx }}>{children}</Box>;
export const WorkspaceOutputArea = ({ children, sx }) => <Box data-workspace-output sx={{ p: { xs: 2, md: 3 }, bgcolor: '#fff', ...sx }}>{children}</Box>;
export const WorkspaceDialogArea = ({ children }) => <>{children}</>;
